import React from 'react'

import Icon from 'components_new/atoms/Icon'
import Switch from 'components_new/atoms/Switch'

import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'
import TextField from 'components_new/atoms/TextField'
import InputAdornment from 'components_new/atoms/InputAdornment'

import { DEFAULT_MOBILE_BREAKPOINT } from 'themes'

import { useTranslation } from 'language/translator'

interface ResponsiveModeProps {
  breakpoint: string | null
  mobile: boolean
  setBreakpoint: (value: string | null) => void
  setMobile: (value: boolean) => void
}

const ResponsiveMode = (props: ResponsiveModeProps) => {
  const { breakpoint, mobile, setBreakpoint, setMobile } = props

  const { t } = useTranslation()

  const handleToggleMobile = () => {
    if (mobile) {
      setBreakpoint(null)
    }
    setMobile(!mobile)
  }

  return (
    <SettingsGroup title={t('dashboards', 'responsive_mode_label')}>
      <SettingsItem
        actions={
          <Switch
            color="success"
            checked={mobile}
            onChange={handleToggleMobile}
            size="medium"
          />
        }
        body={t('dashboards', 'responsive_mode_description')}
        icon={<Icon name={'MobileFriendlyOutlined'} />}
        title={t('global', 'mobile')}
        titleAdornments={<code>?responsive_mode=mobile</code>}
      />

      <SettingsItem
        actions={
          <TextField
            InputProps={{
              inputMode: 'numeric',
              endAdornment: (
                <InputAdornment position="end">
                  {t('global', 'pixels_short')}
                </InputAdornment>
              ),
              pattern: '[0-9]*'
            }}
            noGutter={true}
            onChange={(event) => setBreakpoint(event.target.value)}
            size="small"
            sx={{ width: 128 }}
            type="number"
            value={breakpoint ?? DEFAULT_MOBILE_BREAKPOINT.toString()}
          />
        }
        body={t('dashboards', 'breakpoint_description')}
        disabled={!mobile}
        disabledText={t('dashboards', 'breakpoint_requirement_note')}
        icon={<Icon name={'SwapHorizOutlined'} />}
        title={t('dashboards', 'breakpoint_label')}
        titleAdornments={<code>{'?mobile_breakpoint={number}'}</code>}
      />
    </SettingsGroup>
  )
}

export default ResponsiveMode
